enum ContractAuthenticationStatus {
  EXCEEDED = 'exceeded',
  FAILED = 'failed',
  PENDING = 'pending',
  SUCCEEDED = 'succeeded',
}

export default ContractAuthenticationStatus;
